import { render, staticRenderFns } from "./TransactionListTable.vue?vue&type=template&id=51b713f6&scoped=true&"
import script from "./TransactionListTable.vue?vue&type=script&lang=js&"
export * from "./TransactionListTable.vue?vue&type=script&lang=js&"
import style0 from "./TransactionListTable.vue?vue&type=style&index=0&id=51b713f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b713f6",
  null
  
)

export default component.exports